import React from 'react';
import { ChevronRight, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  showBackButton?: boolean;
  onBack?: () => void;
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  showBackButton = false,
  onBack,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleItemClick = (item: BreadcrumbItem) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.href) {
      navigate(item.href);
    }
  };

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={`flex items-center gap-2 text-sm ${className}`}>
      {showBackButton && (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleBackClick}
          className="p-1 h-auto text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          aria-label="ย้อนกลับ"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
      )}
      
      <nav className="flex items-center">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && (
              <ChevronRight className="h-4 w-4 text-gray-400 mx-1" />
            )}
            
            {index === items.length - 1 ? (
              // Current page - not clickable
              <span className="text-gray-900 font-medium">
                {item.label}
              </span>
            ) : (
              // Previous pages - clickable
              <button
                onClick={() => handleItemClick(item)}
                className="text-gray-600 hover:text-gray-900 hover:underline transition-colors"
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        ))}
      </nav>
    </div>
  );
};

export default Breadcrumb;
